import { useState } from 'react';
import { unstable_batchedUpdates } from 'react-dom';
import { GridToolbarContainer, useGridApiContext } from '@mui/x-data-grid-pro';
import { SaveAlt } from '@material-ui/icons';
import { Button } from 'm2m.components';
import { exportarMovimentacoes } from './exportarMovimentacoes';

export interface ToolbarExportacaoMovimentacoesProps {
  carregarTodasAsMovimentacoes: () => Promise<Array<any>>;
  movimentacoesDaPaginaAtual: Array<any>;
  nomeArquivo: string;
}

const ToolbarExportacaoMovimentacoes: React.FC<ToolbarExportacaoMovimentacoesProps> = ({
  carregarTodasAsMovimentacoes,
  movimentacoesDaPaginaAtual,
  nomeArquivo,
}) => {
  const apiRef = useGridApiContext();
  const [exportando, setExportando] = useState(false);

  const exportar = async () => {
    setExportando(true);
    try {
      await exportarMovimentacoes({
        apiDoGrid: apiRef.current,
        carregarTodasAsMovimentacoes,
        movimentacoesDaPaginaAtual,
        nomeArquivo,
        agruparAtualizacoes: unstable_batchedUpdates,
      });
    } finally {
      setExportando(false);
    }
  };

  return (
    <GridToolbarContainer>
      <Button variant="text" onClick={exportar} disabled={exportando} startIcon={<SaveAlt fontSize="medium" />}>
        {exportando ? 'Exportando...' : 'Exportar'}
      </Button>
    </GridToolbarContainer>
  );
};

export default ToolbarExportacaoMovimentacoes;
